<div class="modal-header">

</div>
<div class="modal-body text-center">
  <p>{{ message }}</p>
</div>
<div class="modal-footer">
  <button type="button" class="btn btn-primary w-md waves-effect waves-light" (click)="modalRef.close('ok')">Ok</button>
</div>
